// extracted by mini-css-extract-plugin
export default {"meals":"MealItem_meals__ZcAcM","cont":"MealItem_cont__r41O8"};